module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphTextleft"
  }, [_vm._v("Some say the world will end in fire,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphTextleft"
  }, [_vm._v(" Some say in ice.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSourceright"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ROBERT FROST")])])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e2582e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icemaidenthe_epi.vue
// module id = 66
// module chunks = 0